import styled from "styled-components";
import { COLORS, responsive } from "../../styles/constants.style";
import {
  textFieldTypographyH4Medium,
  textFieldTypographyH4Regular,
  textFieldTypographyH5SemiBold,
} from "../typography/MuiTypography.style";

export const MuiTextFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 5px;

  ${responsive.MOBILE`
    margin-top: 0;
  `}

  .invisible {
    display: none;
  }

  .title {
    display: flex;
    align-items: baseline;
  }
  .mui-label {
    line-height: 20px;
    color: ${COLORS.cirrus_black10};
    margin-bottom: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
    &.disabled {
      color: ${COLORS.cirrus_black7};
    }
  }
  .asterisk {
    color: ${COLORS.cirrus_red};
  }
  .mui-label-success {
    ${textFieldTypographyH5SemiBold}
    margin-top: 8px;
    line-height: 14px;
    color: ${COLORS.cirrus_green};
  }

  .mui-text-field-success {
    ${textFieldTypographyH4Regular}
    border-width: 1px;
    border-radius: 8px;
    color: ${COLORS.cirrus_black};
    background: ${COLORS.cirrus_black1};
    .MuiOutlinedInput-root {
      .Mui-focused fieldset {
        border-color: ${COLORS.cirrus_green};
        border-width: 2px;
      }
      .MuiOutlinedInput-notchedOutline {
        border-color: ${COLORS.cirrus_green};
        border-width: 2px;
      }
    }
  }

  .mui-text-field {
    ${textFieldTypographyH4Regular}
    color: ${COLORS.cirrus_black};
    .MuiInputBase-input {
      color: ${COLORS.cirrus_black};

      &::placeholder {
        color: ${COLORS.cirrus_black5};
        opacity: 1;
      }
    }

    .MuiOutlinedInput-root {
      border-radius: 8px;
      height: 48px;
      background-color: ${COLORS.cirrus_black1};
      &:hover .MuiOutlinedInput-notchedOutline {
        border-color: ${COLORS.cirrus_black};
      }

      &.Mui-focused .MuiOutlinedInput-notchedOutline {
        border-color: ${COLORS.cirrus_black};
        border-width: 1px;
      }

      &.Mui-error .MuiOutlinedInput-notchedOutline {
        border-color: ${COLORS.cirrus_red};
        border-width: 2px;
      }

      &:hover.Mui-error .MuiOutlinedInput-notchedOutline {
        border-color: ${COLORS.cirrus_red};
      }
      .Mui-disabled {
        -webkit-text-fill-color: ${COLORS.cirrus_black7};
      }
    }
  }

  .MuiInputBase-root .MuiInputAdornment-positionEnd {
    width: 24px;
    height: 24px;

    & > svg {
      cursor: pointer;
    }
  }

  .MuiInputBase-input {
    ${textFieldTypographyH4Medium}
    padding: 11px 16px;
    line-height: 18px;

    &::placeholder {
      color: ${COLORS.cirrus_black10};
    }
  }

  .MuiFormHelperText-root {
    ${textFieldTypographyH5SemiBold}
    margin-top: 8px;
    line-height: 14px;
    color: ${COLORS.cirrus_red};
  }

  .Mui-error {
    margin-left: 0px;
    border-width: 1px;
    border-radius: 8px;
    .MuiOutlinedInput-notchedOutline {
      border-color: ${COLORS.cirrus_red};
      border-width: 2px;
    }
  }
  /* Hide spinners for number input across browsers */
  input[type="number"] {
    -moz-appearance: textfield; /* For Firefox */
    -webkit-appearance: none; /* For Chrome, Safari, Edge */
    appearance: none; /* Standard property */
  }

  input[type="number"]::-webkit-inner-spin-button, /* Chrome, Safari */
  input[type="number"]::-webkit-outer-spin-button {
    /* Chrome, Safari */
    -webkit-appearance: none; /* Remove buttons */
    margin: 0;
  }

  .info-box {
    display: flex;
    flex-direction: row;

    .error-icon {
      display: flex;
      flex-direction: row;
      flex: 90%;
      word-break: break-word;
    }

    .character-count {
      color: ${COLORS.cirrus_black5};
      font-size: 12px;
      text-align: right;
      flex: 10%;
    }
  }

  .mui-textarea {
    .MuiInputBase-root {
      height: 100px;
      background: ${COLORS.cirrus_black1};
      padding: 0px;
    }
  }

  .tooltip-container {
    position: relative;
  }

  .tooltip-wrapper {
    position: absolute;
    bottom: 5px;
  }

  .MuiInputBase-root.Mui-disabled {
    .MuiOutlinedInput-notchedOutline,
    fieldset {
      border-color: rgba(0, 0, 0, 0.26) !important;
      border-color: ${COLORS.cirrus_black2} !important;
      pointer-events: none;
    }
  }

  .Mui-disabled {
    &::placeholder {
      -webkit-text-fill-color: ${COLORS.cirrus_black5};
    }
  }
`;
